<li #notificationelm id="topmenu-notification" class="topmenu-notification" *ngIf="signalList.length > 0" ngbDropdown #notificationDrop="ngbDropdown" (mouseover)='over(notificationDrop)' (mouseout)='notificationDropOut($event, notificationDrop)' display="dynamic" placement="bottom-end">
  <a href="javascript:void(0)" ngbDropdownToggle class="d-block" (click)="notificationDrop.toggle()"></a>
  <div id="menu-container-topmenu-notification" class="menu-control-container topmenu-notification-cls" ngbDropdownMenu>
    <div *ngIf="signalList.length > 0; else noData">
      <!--(click)="$event.stopPropagation()"-->
      <div class="item-notification li-menu-items" *ngFor="let signal of signalList">
        <div class="px-1 py-1" style="justify-content: end; align-items: center; display: flex;">
          <span (click)="closeNotification($event, signal)" *ngIf="signal.StatusCls != 'inprogress'" class="close">&#10005;</span>
        </div>
        <div class="col-12" style="display: flex; justify-content: center;">
          <div style="display: flex; align-items: center;">
            <img class="notification-image" [src]="signal.StatusImg" style="height: 15px;" />
            <span class="notification-titile {{ signal.StatusCls }}">
              {{ signal.Status }}
            </span>
          </div>
          <div class="inapp-message-updated">
            <span class="mx-3">{{ signal.Date }}</span>
          </div>
        </div>
        <div class="col-12 py-2">
          <div class="inapp-message" [innerHTML]="signal.Message | keepHtml"></div>
        </div>
      </div>
    </div>
    <ng-template #noData>
      <div class="no-newnotification">No new notifications</div>
    </ng-template>

  </div>
</li>
